import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  tabContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,
  },
  tabTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0 ${theme.spacing.space24}px`,
  },
  listInventories: {
    display: "flex",
    flexDirection: "row",
    overflowX: "scroll",
    gap: theme.spacing.space8,
    padding: `0 ${theme.spacing.space24}px`,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  listAvatars: {
    display: "grid",
    padding: `0 ${theme.spacing.space24}px`,
    gridGap: theme.spacing.space8,
    gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))",
  },
}));
